<template>
  <validation-observer ref="budgetFormRef" novalidate tag="form">
    <callout
      border-color="green"
      class="mb-4 shadow custom-callout-budget"
      :has-toggle="false"
    >
      <div class="row">
        <div class="col-md-12">
          <icon-view
            :icon="icon"
            icon-background="#fff"
            icon-color="#3dbd8c"
            icon-size="12px"
            :title="title"
          />
        </div>
      </div>
      <div class="row ml-4 pl-1 my-3">
        <div class="col-md-4 col-sm-12">
          <div class="data-name">Año Académico:</div>
          <validation-provider
            v-slot="{ errors }"
            :disabled="editMode"
            rules="required"
          >
            <custom-drop-down
              v-model="model.academicYear"
              :clearable="false"
              custom-error-msg="Favor seleccionar Año Académico."
              :disabled="editMode"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="academicYears"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="data-name">Cantidad de Presupuesto:</div>
          <validation-provider
            v-slot="{ errors }"
            rules="required|differentFromZero"
          >
            <custom-input
              v-model="model.bugdetAmt"
              custom-error-msg=""
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              mask-type="Money"
              prepend-icon="fas fa-dollar-sign"
            />
            <error
              v-if="errors[0]"
              message="Favor de documentar el Presupuesto para el Año Académico."
              variant="no-border mt-1"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 text-right mt-3 pr-5 pt-1">
          <action-button
            i="fas fa-times-circle"
            variant="outline-danger mr-3"
            @click="onCancel"
          >
            Cancelar
          </action-button>
          <action-button
            i="fas fa-save"
            variant="success"
            @click="saveServiceBudgetModal"
          >
            Guardar
          </action-button>
        </div>
      </div>
    </callout>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Callout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import Error from 'custom-error';
import IconView from 'icon-view';
import alertMixin from 'utils/mixins/alert.mixin';
export default {
  name: 'CreateBudget',
  components: {
    ValidationObserver,
    ValidationProvider,
    Callout,
    ActionButton,
    CustomDropDown,
    CustomInput,
    IconView,
    Error,
  },
  mixins: [alertMixin],
  props: {
    academicYears: {
      type: Array,
      default: () => [],
    },
    editMode: {
      type: Boolean,
      default: () => false,
    },
    icon: {
      type: String,
      default: () => 'fas fa-file-plus',
    },
    selectedAcademicYear: {
      type: Object,
      default: () => {},
    },
    serviceBudgetId: {
      type: Object,
      default: () => null,
    },
    title: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      model: {
        academicYear: null,
        bugdetAmt: null,
        id: null,
      },
      validations: {
        invalidNumber: null,
      },
      modal: { show: false },
    };
  },
  watch: {
    selectedAcademicYear: {
      immediate: true,
      handler(newVal) {
        this.model.academicYear = newVal;
      },
    },
    serviceBudgetId: {
      immediate: true,
      handler(newVal) {
        this.model.id = newVal;
      },
    },
  },
  async created() {
    this.Message = '¿Está seguro que desea confirmar el nuevo presupuesto?';
    if (this.editMode) {
      this.Message = '¿Está seguro que desea editar el presupuesto?';
    }
  },
  methods: {
    validateNumber() {
      if (this.model.bugdetAmt <= 0) {
        this.validations.invalidNumber =
          'Favor de documentar el Presupuesto para el Año Académico.';
        return false;
      } else {
        this.validations.invalidNumber = null;
        return true;
      }
    },
    async saveServiceBudgetModal() {
      const isValid = await this.$refs.budgetFormRef.validate();
      const _isValidNumber = this.validateNumber();

      if (!isValid || !_isValidNumber) {
        let msj =
          'Favor de completar la información solicitada para continuar con la creación del Nuevo Presupuesto.';
        if (this.editMode) {
          msj =
            'Favor ingrese la cantidad de presupuesto para continuar con la actualización.';
        }
        this.ShowToast('Alerta', msj, 'error');
        return;
      }
      const answer = await this.ShowCancelModal(
        'Confirmación',
        this.Message,
        'Sí',
        'No'
      );
      if (answer) {
        this.onSave();
      }
    },
    onCancel() {
      this.modal.show = false;
      this.$emit('on-cancel');
    },
    async onSave() {
      this.$emit('on-save', this.model);
    },
  },
};
</script>

<style scoped lang="scss">
.custom-callout-budget {
  ::v-deep .callout-container {
    border-left-width: 5px;
  }
}
</style>
